import LogoType from './LogoType';
import GrayscaleLogo from '@/assets/logo/logo-symbol-grayscale.png';
import ColorLogo from '@/assets/logo/logo-symbol-color.svg';
import clsx from 'clsx';

const DFullLogo = ({ mode, variant, size = 'md' }) => {
  let sizeSymbolClass = 'size-auto object-center';
  let sizeTypeClass = 'h-4';

  if (size === 'xs') {
    sizeSymbolClass = 'size-3 object-center';
    sizeTypeClass = 'h-3 w-[40px]';
  }
  if (size === 'lg') {
    sizeSymbolClass = 'size-6 object-center';
    sizeTypeClass = 'h-6';
  }

  const symbol = () => {
    if (variant === 'grayscale') {
      return <img src={GrayscaleLogo} className={sizeSymbolClass} />;
    }
    return <img src={ColorLogo} className={sizeSymbolClass} />;
  };

  if (mode === 'dark') {
    return (
      <div className="transition-all duration-150 flex gap-[4px] items-center">
        {symbol()}
        <LogoType className={clsx(sizeTypeClass, 'text-[#fff]/85')} />
      </div>
    );
  }
  return (
    <div className="transition-all duration-150 flex gap-[4px] items-center">
      {symbol()}
      <LogoType
        className={clsx(sizeTypeClass, 'text-[var(--dt-color-element-100)]')}
      />
    </div>
  );
};

export default DFullLogo;
